module.exports = __webpack_public_path__ + "static/Pivot-bfd822aac5d1bff8a85c9bb27a80bb00.jpg";